import Vue from "vue";
import Vuex from "vuex";

// modules
import VuexPersist from "vuex-persist";
import Projects from "./modules/projectStore";
import Sidebars from "./modules/sidebarsStore";
import Languages from "./modules/languageStore";
import loginUser from "./modules/loginUser";
import geometryStore from "./modules/geometryStore";
import pheStore from "./modules/pheStore";
import offertaStore from "./modules/offertaStore";
import userProfileStore from "./modules/userProfileStore";
import umsStore from "./modules/umsStore";

const vuexPersist = new VuexPersist({
  key: "unilab-world",
  storage: localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    prjModule: Projects,
    sidebarModule: Sidebars,
    languages: Languages,
    loginUser,
    geometryStore,
    pheStore,
    offertaStore,
    userProfileStore,
    umsStore
  },
  plugins: [vuexPersist.plugin]
});
